import photos from "./photos";

const slides = photos.map(
  ({ src, srcGallery, width, height, type, images }) => ({
    src: srcGallery,
    width,
    height,
    imgType: type,
    srcSet: images.map((image) => ({
      src: image.src,
      width: image.width,
      height: image.height,
    })),
  })
);

export default slides;
